import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import './App.css';
import AboutUs from './Components/About/AboutUs';
import Team from './Components/About/Team';
import Career from './Components/Career/Career';
import Case from './Components/Case/Case';
import Freshee from './Components/Case/Freshee';
import Neewee from './Components/Case/Neewee';
import Snapmint from './Components/Case/Snapmint';
import Hrone from './Components/Case/Hrone';
import Medkart from './Components/Case/Medkart';
import Sunsure from './Components/Case/Sunsure';
import Sukhhi from './Components/Case/Sukhhi';
import Contactus from './Components/Contact/Contactus';
import Cren from './Components/Credentials/Cren';
import Home from './Components/Home/Home';
import ScrollToTop from './Components/ScrollToTop';
import Services from './Components/Services/Services';
import Abhishek from './Components/Team/Abhishek';
import Ankit from './Components/Team/Ankit';
import Ashish from './Components/Team/Ashish';
import Jay from './Components/Team/Jay';
import Mahesh from './Components/Team/Mahesh';
import Maya from './Components/Team/Maya';
import Thankyou from './Components/Thankyou/Thankyou';
import Footer from './Layout/Footer';
import Header from './Layout/Header';
import Akash from './Components/Team/Akash';
import Vignesh from './Components/Team/Vignesh'


function App() {
  return (
    <>
    <Router>
      <ScrollToTop/>
      <Header/>
        <Switch>
          <Route exact path="/">
            <Home/>
          </Route>
          <Route exact path="/contact_us">
            <Contactus/>
          </Route>
          <Route exact path="/about_us">
            <AboutUs/>
          </Route>
          <Route exact path="/credential">
            <Cren/>
          </Route>
          <Route exact path="/career">
            <Career/>
          </Route>
          <Route exact path="/service">
            <Services/>
          </Route>
          <Route exact path="/case_study">
            <Case/>
          </Route>
          <Route exact path="/neewee">
            <Neewee/>
          </Route>
          <Route exact path="/freshee">
            <Freshee/>
          </Route>
          <Route exact path="/sukhhi">
            <Sukhhi/>
          </Route>
          <Route exact path="/hrone">
            <Hrone/>
          </Route>
          <Route exact path="/sunsure">
            <Sunsure/>
          </Route>
          <Route exact path="/fmedkart">
            <Medkart/>
          </Route>
          <Route exact path="/team">
            <Team/>
          </Route>
          <Route exact path="/abhishek">
            <Abhishek/>
          </Route>
          <Route exact path="/maya">
            <Maya/>
          </Route>
          <Route exact path="/ankit">
            <Ankit/>
          </Route>
          <Route exact path="/mahesh">
            <Mahesh/>
          </Route>
          <Route exact path="/akash">
            <Akash/>
          </Route>
          <Route exact path="/vignesh">
            <Vignesh/>
          </Route>
          <Route exact path="/jay">
            <Jay/>
          </Route>
          <Route exact path="/ashish">
            <Ashish/>
          </Route>
          <Route exact path="/snapmint">
            <Snapmint/>
          </Route>
          <Route exact path="/thankyou">
            <Thankyou/>
          </Route>
        </Switch>
        <Footer/>
    </Router>
    </>
  );
}

export default App;
